import { useTheme } from '@mui/material/styles';
import { brandColors } from '../../theme';
import { styleConstants } from '../../Utils/styleConsts';
export const useStyles = () => {
    const theme = useTheme();
    return {
        root: {
            borderRadius: styleConstants.borderRadius,
            border: `2px solid ${brandColors.light}`,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            padding: `${theme.spacing(2)} ${theme.spacing(2)}`,
            textDecoration: 'none',
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.background.paper,
            [theme.breakpoints.up('md')]: {
                minHeight: '10rem',
            },
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'row',
                padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
            },
            '&:hover': {
                borderColor: theme.palette.primary.main,
                outline: `3px solid ${theme.palette.primary.main}`,
                outlineOffset: '-3px',
            },
            '&:focus': {
                borderColor: theme.palette.primary.main,
                outline: 'none',
            },
            '&:hover h4': {
                color: theme.palette.primary.main,
            }
        },
        disabled: {
            borderColor: theme.palette.grey[200],
            '&:hover': {
                borderColor: theme.palette.grey[200],
                cursor: 'default',
            },
            '& h4': {
                color: theme.palette.grey[500],
            },
        },
        img: {
            '& > img': {
                width: '100%',
            },
        },
        button: {
            '& > span': {
                flexDirection: 'column',
                [theme.breakpoints.down('xs')]: {
                    flexDirection: 'row',
                },
            },
            '&:hover': {
                backgroundColor: theme.palette.background.paper,
            },
        },
    };
};
